import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

// NOTE: Firebase Web config values are PUBLIC by design (not secrets) — safe to
// keep as fallbacks. Env vars override them when the host injects REACT_APP_FIREBASE_*.
const env = process.env;
const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCZxmlK4_BXSrO0miGW6yAcZUXB8aTAUN0",
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || "shivaputra-project.firebaseapp.com",
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID || "shivaputra-project",
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || "shivaputra-project.firebasestorage.app",
  messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "407090748719",
  appId: env.REACT_APP_FIREBASE_APP_ID || "1:407090748719:web:137b59fd18a667f14d55da",
};

const app = getApps()[0] || initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
